import { IDanhSachMoMonRequest } from "./../../reducer-model/lop-tin-chi/IDanhSachMoMonReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachMoMonReducer } from "../../reducer-model/lop-tin-chi/IDanhSachMoMonReducer";
import { IDanhSachMoMonActions } from "../../action-types/lop-tin-chi/IDanhSachMoMonActions";
const iniState: IDanhSachMoMonReducer = {
  status: eReducerStatusBase.is_not_initialization,
  statusExport: eReducerStatusBase.is_not_initialization,
  filter: {
    id_chuyen_nganh: 0,
    id_giai_doan: 0,
    id_he: 0,
    ky_dang_ky: 0,
  } as IDanhSachMoMonRequest,
};
export const danhSachMoMonReducer = (
  state: IDanhSachMoMonReducer = iniState,
  actions: IDanhSachMoMonActions
): IDanhSachMoMonReducer => {
  switch (actions.type) {
    case "DANH_SACH_MO_MON_CHANGE_FILTER":
      return {
        ...state,
        filter: {
          ...state.filter,
          ...actions.payload,
        },
      };
    case "DANH_SACH_MO_MON_EXPORT_EXCEL_START":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_loading,
      };
    case "DANH_SACH_MO_MON_EXPORT_EXCEL_SUCCESS":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    case "DANH_SACH_MO_MON_EXPORT_EXCEL_ERROR":
      return {
        ...state,
        statusExport: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
